import React from 'react';
import { SalesPage } from './pages/SalesPage';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <>
      <MetaPixel data-id="element-0" />
      <SalesPage data-id="element-1" />
    </>;
}